export default function VPN() {
  const features = [
    'Military-grade AES-256 encryption',
    'Global server network in 50+ countries',
    'Strict zero-log policy',
    'Lightning-fast connection speeds',
    'Kill switch protection',
    'Multi-device support'
  ];

  return (
    <section id="vpn" className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/20 to-blue-500/20 rounded-3xl blur-3xl"></div>
            <div className="relative w-full h-96 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ae8562bc8a1a32dfd7edfd44495cd69a.jpg"
                alt="VPN Dashboard"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <span className="inline-block text-teal-400 text-sm font-semibold uppercase tracking-wide mb-4">
              Our Flagship Product
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Enterprise-Grade<br />VPN Solution
            </h2>
            <p className="text-gray-300 leading-relaxed mb-8">
              Experience unparalleled security and privacy with our advanced VPN technology. Protect your data, bypass restrictions, and browse anonymously with confidence.
            </p>

            <div className="space-y-4 mb-10">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-xl text-teal-400"></i>
                  </div>
                  <span className="text-white text-base">{feature}</span>
                </div>
              ))}
            </div>

            <button className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
              Learn More
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
